import { RippleButton } from '@3plearning/chakra-mathletics-theme'
import { ErrorModal, type ErrorModalProps } from '../../modal/ErrorModal'
import NotFoundErrorImage from './assets/Lost Connection.svg'

type Props =
  & Omit<ErrorModalProps, 'headingText' | 'messageText'>
  // Make the text optional for localisation
  & Partial<Pick<ErrorModalProps, 'headingText' | 'messageText'>>
  & {
  refreshText?: string
}

export function NetworkErrorPage({
  headingText = 'Uh-oh! Something has gone wrong.',
  messageText = 'You\'re not connected to the internet. Make sure you’re connected to the internet and click refresh.',
  refreshText = 'Refresh',
  ...props
}: Props) {
  const onRefresh = () => {
    window.location.reload()
  }

  return (
    <ErrorModal
      headingText={headingText}
      messageText={messageText}
      imageSrc={NotFoundErrorImage}
      buttons={[
        () => (
          <RippleButton onClick={onRefresh}>
            {refreshText}
          </RippleButton>
        )
      ]}
      {...props}
    />
  )
}
